import { createSelector } from 'reselect';
import { getHydratedData } from '../redux/hydrated-data/hydrated-data';

export const getCurrentLocale = createSelector(
  getHydratedData,
  (data) => data.locale,
);
